import icons from './icons.js';

let imageList = icons;

export default imageList;
